import { render, staticRenderFns } from "./evento-ficha.vue?vue&type=template&id=427c88ec"
import script from "./evento-ficha.vue?vue&type=script&lang=js"
export * from "./evento-ficha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports